import * as tslib_1 from "tslib";
import { OnInit, EventEmitter, Renderer2 } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { forkJoin, timer } from 'rxjs';
import { take } from 'rxjs/operators';
import { InvestorAccount } from 'src/app/models/investor-account';
import { InvestorDetails } from 'src/app/models/investor-details';
import { OnboardingService } from 'src/app/services/rest/onboarding.service';
import { UtilsService } from 'src/app/utils/utils.service';
import { SharedService } from 'src/app/services/shared/shared.service';
import { CaptchaService } from 'src/app/services/captcha/captcha.service';
/** otp verification  */
var OtpVerifyComponent = /** @class */ (function () {
    /**
     * initial component call
     * @param formBuilder FormBuilder
     * @param rest OnboardingService
     * @param utils UtilsService
     * @param shared SharedService
     * @param captcha CaptchaService
     * @param renderer Renderer2
     */
    function OtpVerifyComponent(formBuilder, rest, utils, shared, captcha, renderer) {
        this.formBuilder = formBuilder;
        this.rest = rest;
        this.utils = utils;
        this.shared = shared;
        this.captcha = captcha;
        this.renderer = renderer;
        this.onActionClicked = new EventEmitter();
        this.investor = this.utils.getOnboardingData();
        this.businessInfo = this.utils.getBusinessUnit();
        this.config = { mobileVerified: false, emailVerified: false, maxTime: 30 };
        this.config.isReferCodeHidden = (this.utils.getSource() || '').toLowerCase() == 'thirdparty' && this.utils.getReferCode();
        this.routeInfo = this.utils.getRouteInfo('otp-popup');
        this.currentUrl = location.href;
        this.initializeForm();
    }
    /** Life Cycle hook  after initialized all data-bound properties */
    OtpVerifyComponent.prototype.ngOnInit = function () {
        this.config.getMobileOtp = window.location.pathname.indexOf("/onboard") > -1 ? true : false;
        this.captcha.initiateCaptchaScript(this.renderer);
        var otpConfig = this.utils.getOtpConfig() || {};
        var investorDetails = (this.investor.investorDetailsDtoList || [])[0] || new InvestorDetails();
        var investorAccountDetails = (this.investor.investorAccountDetailsDtoList || [])[0] || new InvestorAccount();
        this.config.mobileVerified = (investorAccountDetails.isMobileVerified != 'Y') ? false : true;
        this.config.emailVerified = (investorAccountDetails.isEmailVerified != 'Y') ? false : true;
        this.verifyForm(this.formValues);
    };
    /** Method to Initialize Form */
    OtpVerifyComponent.prototype.initializeForm = function () {
        var inputs = this.routeInfo.inputs;
        this.formGroup = this.formBuilder.group({
            mobOtp: new FormControl('', inputs.mobOtp.validations || inputs.mobOtp[this.businessInfo + 'Validators']),
            emailOtp: new FormControl('', inputs.emailOtp.validations || inputs.emailOtp[this.businessInfo + 'Validators'])
        });
    };
    /**
     * verify otp
     * @param values passing otp
     */
    OtpVerifyComponent.prototype.verifyForm = function (values) {
        this.investor = this.utils.getOnboardingData();
        var investorDetails = (this.investor.investorDetailsDtoList || [])[0] || new InvestorDetails();
        var investorAccountDetails = (this.investor.investorAccountDetailsDtoList || [])[0] || new InvestorAccount();
        this.config.isMobileNotVerified = !investorDetails.mobileNum || values.mobileNumber != investorDetails.mobileNum || investorAccountDetails.isMobileVerified != 'Y';
        this.config.isEmailNotVerified = !investorDetails.emailID || values.email != investorDetails.emailID || investorAccountDetails.isEmailVerified != 'Y';
        if (this.utils.otpFormModal.otpGenerated) {
            this.setOTPTimer(this.config.isMobileNotVerified, this.config.isEmailNotVerified);
        }
        else if (this.config.isEmailNotVerified || this.config.isMobileNotVerified) {
            this.sendOnboardOTP(this.config.isMobileNotVerified ? values.mobileNumber : null, this.config.isEmailNotVerified ? values.email : null, false);
        }
        else if (!(this.config.isEmailNotVerified && this.config.isMobileNotVerified)) {
            this.shared.setOtpStatus({ investor: this.investor, verified: true, action: 'submit' });
            this.onActionClicked.emit({ investor: this.investor, verified: true, action: 'submit' });
        }
    };
    /**
     *  set timer 30 sec
     * @param isMobile boolean value for mobile
     * @param isEmail  boolean value for email
     */
    OtpVerifyComponent.prototype.setOTPTimer = function (isMobile, isEmail) {
        var _this = this;
        if (isMobile) {
            this.config.mobSubscription = timer(0, 1000).pipe(take(this.config.maxTime)).subscribe(function (value) {
                _this.config.mobValue = _this.config.maxTime - (value);
            });
        }
        if (isEmail) {
            this.config.emailSubscription = timer(0, 1000).pipe(take(this.config.maxTime)).subscribe(function (value) {
                _this.config.emailValue = _this.config.maxTime - (value);
            });
        }
    };
    /**
     * for sending onboarding otp
     * @param mobile passing mobile number
     * @param email passing email
     * @param isResend boolean value for resend or not
     */
    OtpVerifyComponent.prototype.sendOnboardOTP = function (mobile, email, isResend) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var forkList, otpConfig, investorAccountDetails, token, mobilePayload, emailPayload;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        forkList = {};
                        otpConfig = this.utils.getOtpConfig() || {};
                        investorAccountDetails = (this.investor.investorAccountDetailsDtoList || [])[0] || new InvestorAccount();
                        if (!mobile) return [3 /*break*/, 2];
                        token ? this.captcha.removeCaptchaScript(this.renderer) : "";
                        return [4 /*yield*/, this.captcha.checkCaptcha()];
                    case 1:
                        token = _a.sent();
                        mobilePayload = {
                            mobileNumber: parseInt(mobile),
                            otpType: isResend ? "Resend" : "",
                            investorId: this.investor.id,
                            ssoSubjectId: this.investor.investorAccountDetailsDtoList[0].ssoSubjectId || '',
                            purpose: "mobile",
                            captcha_resp: token,
                            old_session_id: this.config.mobileOTPReference
                        };
                        mobile && (investorAccountDetails.isMobileVerified == 'N' || this.config.isMobileNotVerified) ? forkList.mobile = this.rest.sendOnboardOTP(mobilePayload, this.utils.getOriginalSource().trim() === 'ALPHABEE', this.investor.id) : '';
                        _a.label = 2;
                    case 2:
                        if (!email) return [3 /*break*/, 4];
                        token ? this.captcha.removeCaptchaScript(this.renderer) : "";
                        return [4 /*yield*/, this.captcha.checkCaptcha()];
                    case 3:
                        token = _a.sent();
                        emailPayload = {
                            email: email,
                            otpType: isResend ? "Resend" : "",
                            investorId: this.investor.id,
                            ssoSubjectId: this.investor.investorAccountDetailsDtoList[0].ssoSubjectId || '',
                            purpose: "email",
                            captcha_resp: token,
                            old_session_id: this.config.emailOTPReference
                        };
                        email && (investorAccountDetails.isEmailVerified == 'N' || this.config.isEmailNotVerified) ? forkList.email = this.rest.sendOnboardOTP(emailPayload, this.utils.getOriginalSource().trim() === 'ALPHABEE', this.investor.id) : '';
                        _a.label = 4;
                    case 4:
                        forkJoin(forkList).subscribe(function (res) {
                            var message = 'OTP has been ' + (isResend ? ' resent ' : 'sent ') + 'on given ';
                            if (forkList.mobile && res && res.mobile && res.mobile.Body) {
                                var mobileRes = res.mobile.Body;
                                if (isResend) {
                                    message = 'You will soon receive OTP given Mobile Number';
                                }
                                else {
                                    message += 'Mobile Number';
                                }
                                _this.config.mobileOTPReference = mobileRes.sessionId;
                            }
                            if (forkList.email && res && res.email && res.email.Body) {
                                var emailRes = res.email.Body;
                                if ((message.indexOf('Mobile Number') > -1) && isResend) {
                                    message += ' and an OTP on Email Address';
                                }
                                else {
                                    message += ((message.indexOf('Mobile Number') > -1 ? ' and' : '') + ' Email Address');
                                }
                                _this.config.emailOTPReference = emailRes.sessionId;
                            }
                            _this.utils.setOtpConfig({ mobileOTPReference: _this.config.mobileOTPReference || otpConfig.mobileOTPReference || '', emailOTPReference: _this.config.emailOTPReference || otpConfig.emailOTPReference || '' });
                            message += '. Kindly check';
                            if (message.indexOf('Mobile Number') > -1 || message.indexOf('Email Address') > -1) {
                                _this.utils.success('Success', message);
                                _this.utils.setOtpConfig({ otpGenerated: true });
                                if (!isResend) {
                                    _this.config.otpForm = true;
                                }
                                _this.setOTPTimer(forkList.mobile, forkList.email);
                            }
                            else {
                                _this.utils.error("Attention!!", res.Message ? res.Message :
                                    "Something went wrong from our end. Please try again");
                            }
                        }, function (err) {
                            _this.utils.error("Attention!!", err.error.Message ? err.error.Message + " For Mobile Number" :
                                "Something went wrong from our end. Please try again");
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * verification OTP
     * @param mobileOtp passing mobile otp
     * @param emailOtp passing email otp
     * @param proceed sumbit basis
     */
    OtpVerifyComponent.prototype.verifyOTP = function (mobileOtp, emailOtp, proceed) {
        var _this = this;
        if (!this.contactUpdationType) {
            if (mobileOtp && emailOtp && !this.config.mobileVerified && !this.config.emailVerified) {
                this.contactUpdationType = 'both';
            }
            else if (mobileOtp && !this.config.mobileVerified) {
                this.contactUpdationType = 'mobile';
            }
            else {
                this.contactUpdationType = 'email';
            }
        }
        var otpConfig = this.utils.getOtpConfig();
        var forkList = {};
        this.investor = this.utils.getOnboardingData();
        var message = '';
        if (mobileOtp && !this.config.mobileVerified) {
            var payload = {
                sessionId: this.config.mobileOTPReference || otpConfig.mobileOTPReference,
                otp: mobileOtp
            };
            this.rest.verifyOnboardOTP(payload, this.investor.id).subscribe(function (res) {
                if (res && res.Body !== null && typeof res.Body === 'object' && Object.keys(res.Body).length > 0) {
                    // let mobileRes = res.Body;
                    _this.config.mobileVerified = true;
                    _this.investor.investorAccountDetailsDtoList[0].isMobileVerified = 'N';
                    _this.investor.investorDetailsDtoList[0].mobileOtp = null;
                    _this.investor.investorAccountDetailsDtoList[0].isMobileVerified = _this.config.mobileVerified ? 'Y' : 'N';
                    _this.investor.investorDetailsDtoList[0].mobileOtp = mobileOtp;
                    _this.investor.investorDetailsDtoList[0].mobileNum = _this.config.mobileVerified ? _this.formValues.mobileNumber : _this.investor.investorDetailsDtoList[0].mobileNum;
                    _this.utils.updateOnboardingData(_this.investor);
                    _this.utils.setOtpConfig({ 'emailVerified': _this.config.emailVerified, 'mobileVerified': _this.config.mobileVerified, contactUpdationType: _this.contactUpdationType });
                    if (_this.investor.investorAccountDetailsDtoList[0].isMobileVerified == 'Y' && _this.investor.investorAccountDetailsDtoList[0].isEmailVerified == 'Y') {
                        _this.utils.removeOtpConfig();
                        _this.shared.setOtpStatus({ investor: _this.investor, verified: true, action: 'submit', proceed: proceed });
                        _this.onActionClicked.emit({ investor: _this.investor, verified: true, action: 'submit', contactUpdationType: _this.contactUpdationType });
                    }
                }
                else {
                    _this.utils.error("Attention!!", res.Message ? res.Message :
                        "Something went wrong from our end. Please try again");
                    _this.config.mobileVerified = false;
                }
            }, function (err) {
                _this.utils.error("Attention!!", err.error.Message ? err.error.Message + " For Mobile Number" :
                    "Something went wrong from our end. Please try again");
                message = 'Invalid or expired OTP for mobile number';
                _this.config.mobileVerified = false;
            });
        }
        if (emailOtp && !this.config.emailVerified) {
            var emailpayload = {
                sessionId: this.config.emailOTPReference || otpConfig.emailOTPReference,
                otp: emailOtp
            };
            this.rest.verifyOnboardOTP(emailpayload, this.investor.id).subscribe(function (res) {
                if (res && res.Body !== null && typeof res.Body === 'object' && Object.keys(res.Body).length > 0) {
                    var emailRes = res.Body;
                    _this.config.emailVerified = true;
                    _this.investor.investorAccountDetailsDtoList[0].isEmailVerified = 'N';
                    _this.investor.investorDetailsDtoList[0].emailOtp = null;
                    _this.investor.investorAccountDetailsDtoList[0].isEmailVerified = _this.config.emailVerified ? 'Y' : 'N';
                    _this.investor.investorDetailsDtoList[0].emailOtp = emailOtp;
                    _this.investor.investorDetailsDtoList[0].emailID = _this.config.emailVerified ? _this.formValues.email : _this.investor.investorDetailsDtoList[0].emailID;
                    _this.utils.updateOnboardingData(_this.investor);
                    _this.utils.setOtpConfig({ 'emailVerified': _this.config.emailVerified, 'mobileVerified': _this.config.mobileVerified, contactUpdationType: _this.contactUpdationType });
                    if (_this.investor.investorAccountDetailsDtoList[0].isMobileVerified == 'Y' && _this.investor.investorAccountDetailsDtoList[0].isEmailVerified == 'Y') {
                        _this.utils.removeOtpConfig();
                        _this.shared.setOtpStatus({ investor: _this.investor, verified: true, action: 'submit', proceed: proceed });
                        _this.onActionClicked.emit({ investor: _this.investor, verified: true, action: 'submit', contactUpdationType: _this.contactUpdationType });
                    }
                }
                else {
                    _this.utils.error("Attention!!", res.Message ? res.Message :
                        "Something went wrong from our end. Please try again");
                    _this.config.emailVerified = false;
                }
            }, function (err) {
                _this.utils.error("Attention!!", err.error.Message ? err.error.Message + " For Email address" :
                    "Something went wrong from our end. Please try again");
                message += ((!_this.config.mobileVerified) ? ' and email' : 'Invalid or expired OTP for email address');
                _this.config.emailVerified = false;
            });
        }
        // forkJoin(forkList).subscribe((res: any) => {
        //   let message = '';
        //   if(mobileOtp){
        //     let mobileRes = res.mobile.Body;
        //     this.config.mobileVerified = true;
        //     if (forkList.mobile && typeof mobileRes != 'boolean' && (mobileRes.error || mobileRes.errorCode)) {
        //       message = 'Invalid or expired OTP for mobile number';
        //       this.config.mobileVerified = false;
        //       if (forkList.mobile && typeof mobileRes != 'boolean' && (mobileRes.error || mobileRes.errorCode)) {
        //         message = 'Invalid or expired OTP for mobile number';
        //         this.config.mobileVerified = false;
        //       }
        //     }
        //     this.investor.investorAccountDetailsDtoList[0].isMobileVerified = 'N';
        //     this.investor.investorDetailsDtoList[0].mobileOtp = null;
        //     this.investor.investorAccountDetailsDtoList[0].isMobileVerified = this.config.mobileVerified ? 'Y' : 'N';
        //     this.investor.investorDetailsDtoList[0].mobileOtp = mobileOtp;
        //     this.investor.investorDetailsDtoList[0].mobileNum = this.config.mobileVerified ? this.formValues.mobileNumber : this.investor.investorDetailsDtoList[0].mobileNum;        
        //   }
        //   if(emailOtp){
        //     let emailRes = res.email.Body;
        //     this.config.emailVerified = true;
        //     if (forkList.email && typeof emailRes != 'boolean' && (emailRes.error || emailRes.errorCode)) {
        //       message += ((forkList.mobile && !this.config.mobileVerified) ? ' and email' : 'Invalid or expired OTP for email address');
        //       this.config.emailVerified = false;
        //     }
        //     this.investor.investorAccountDetailsDtoList[0].isEmailVerified = 'N';
        //     this.investor.investorDetailsDtoList[0].emailOtp = null;
        //     this.investor.investorAccountDetailsDtoList[0].isEmailVerified = this.config.emailVerified ? 'Y' : 'N';
        //     this.investor.investorDetailsDtoList[0].emailOtp = emailOtp;
        //     this.investor.investorDetailsDtoList[0].emailID = this.config.emailVerified ? this.formValues.email : this.investor.investorDetailsDtoList[0].emailID;
        //   }
        //   message ? this.utils.error('Error!!', message) : '';
        //   this.utils.updateOnboardingData(this.investor);
        //   this.utils.setOtpConfig({ 'emailVerified': this.config.emailVerified, 'mobileVerified': this.config.mobileVerified, contactUpdationType: this.contactUpdationType });
        //   if (this.investor.investorAccountDetailsDtoList[0].isMobileVerified == 'Y' && this.investor.investorAccountDetailsDtoList[0].isEmailVerified == 'Y') {
        //     this.utils.removeOtpConfig();
        //     this.shared.setOtpStatus({ investor: this.investor, verified: true, action: 'submit',proceed:proceed })
        //     this.onActionClicked.emit({ investor: this.investor, verified: true, action: 'submit', contactUpdationType: this.contactUpdationType });
        //   }
        // }, (err) => {
        //   this.utils.error(
        //     "Attention!!",
        //     err.error.Message ||
        //       "Something went wrong from our end. Please try again"
        //   );
        // });
    };
    /** cancel otp verification */
    OtpVerifyComponent.prototype.cancelOTPVerify = function () {
        this.shared.setOtpStatus({ investor: this.investor, verified: false, action: 'cancel' });
        this.onActionClicked.emit({ investor: this.investor, verified: false, action: 'cancel', contactUpdationType: this.contactUpdationType });
        this.utils.setOtpConfig({ isHidden: true, isSkip: false });
    };
    /** skip form */
    OtpVerifyComponent.prototype.skipForm = function () {
        if (this.investor.investorDetailsDtoList[0].dateOfBirth)
            if (sessionStorage.getItem('isBelow25') === 'true') {
                this.utils.pushDataLayerEvent({
                    'event': 'details_do_later_with_below25',
                    'platform': window.innerWidth < 767 ? 'mobileweb' : 'desktopweb',
                    'page_path': window.location.pathname,
                    'page_url': window.location.href,
                    'userId': this.utils.generateSHA256Hash(this.investor.investorDetailsDtoList[0].mobileNum.toString()),
                    'lead_source': this.investor.investorAccountDetailsDtoList[0].originalSource.toLowerCase() || "website",
                    'phone': this.utils.generateSHA256Hash(this.investor.investorDetailsDtoList[0].mobileNum),
                    'custom_source': sessionStorage.getItem('custom_source') || "",
                    'custom_medium': sessionStorage.getItem('custom_medium') || "",
                    'custom_campaign': sessionStorage.getItem('custom_campaign') || ""
                });
            }
            else {
                this.utils.pushDataLayerEvent({
                    'event': 'details_do_later',
                    'platform': window.innerWidth < 767 ? 'mobileweb' : 'desktopweb',
                    'page_path': window.location.pathname,
                    'page_url': window.location.href,
                    'userId': this.utils.generateSHA256Hash(this.investor.investorDetailsDtoList[0].mobileNum.toString()),
                    'lead_source': this.investor.investorAccountDetailsDtoList[0].originalSource.toLowerCase() || "website",
                    'phone': this.utils.generateSHA256Hash(this.investor.investorDetailsDtoList[0].mobileNum),
                    'custom_source': sessionStorage.getItem('custom_source') || "",
                    'custom_medium': sessionStorage.getItem('custom_medium') || "",
                    'custom_campaign': sessionStorage.getItem('custom_campaign') || ""
                });
            }
        this.shared.setOtpStatus({ investor: this.investor, verified: false, action: 'skip' });
        this.onActionClicked.emit({ investor: this.investor, verified: false, action: 'skip' });
        this.utils.setOtpConfig({ isHidden: true, isSkip: true });
        // this.utils.info('Skipping for Now', 'You can enter OTP anytime before completing just by clicking OTP button in bottom right');
        this.utils.info('Skipping for Now', 'You can enter OTP before submission of onboarding application');
    };
    /** Life Cycle hook  Cleanup just before Angular destroys the directive/component */
    OtpVerifyComponent.prototype.ngOnDestroy = function () {
        this.contactUpdationType = '';
        if (this.abortController) {
            this.abortController.abort();
        }
    };
    /**  invoked immediately after Angular has completed initialization of a component's view.*/
    OtpVerifyComponent.prototype.ngAfterViewInit = function () {
        this.fetchOTP();
    };
    /**  fetching  otp value*/
    OtpVerifyComponent.prototype.fetchOTP = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!('OTPCredential' in window)) return [3 /*break*/, 2];
                        this.abortController = new AbortController();
                        return [4 /*yield*/, navigator.credentials.get({
                                otp: { transport: ['sms'] },
                                signal: this.abortController.signal
                            }).then(function (otp) {
                                var otpObj;
                                otpObj = otp;
                                if (_this.formGroup && _this.formGroup.get('mobOtp') && otpObj && otpObj.code) {
                                    _this.formGroup.get('mobOtp').patchValue(otpObj.code);
                                }
                                // ac.abort();
                            }).catch(function (err) {
                                console.log(err, "error");
                                // ac.abort();
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return OtpVerifyComponent;
}());
export { OtpVerifyComponent };
